import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <span className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
              DynastyForge
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('process')} className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap">
              Process
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap">
              Portfolio
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-3 rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap">
              Book Now
            </button>
          </div>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-700 hover:text-purple-600 py-2 cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('process')} className="block w-full text-left text-gray-700 hover:text-purple-600 py-2 cursor-pointer">
              Process
            </button>
            <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left text-gray-700 hover:text-purple-600 py-2 cursor-pointer">
              Portfolio
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-700 hover:text-purple-600 py-2 cursor-pointer">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-3 rounded-full w-full whitespace-nowrap">
              Book Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
